<div class="modalOverlay takeOwnershipModal" style="z-index: 1600;">
    <div class="modalPositioner">
        <div class="modalContainer">
            <cv-loader [hidden]="!showLoader"></cv-loader>
            <!-- Header -->
            <button type="button" class="icon-btn fill-iconDefault modal-close" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
            <div class="modalHeader">
                <span class="titleText"></span>
            </div>

            <!-- Body -->
            <div class="modalBody">
                <ag-grid-angular 
                    #takeOwnershipGrid
                    *ngIf="gridOptions !== null"
                    class="ag-theme-balham flex-fill mt-4"
                    [gridOptions]="gridOptions"
                    style="height: 50vh;">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>
